import { type SxProps, type Theme } from "@mui/material/styles";

import { InputControl } from "ui/forms";
import { Skeleton } from "ui/skeleton";

import { CONTROL_HEIGHT } from "theme/components/field-geometry";

type FieldSkeletonProps = {
  label: string;
  sx?: SxProps<Theme>;
};

/**
 * Holds a medium field's place while its value loads. `ui/text-field` and `ui/select` render their label
 * through the same `InputControl`, so the row does not move when the real field replaces this one.
 */
export const FieldSkeleton = ({ label, sx }: FieldSkeletonProps) => (
  <InputControl label={label} sx={sx}>
    <Skeleton variant="rounded" height={CONTROL_HEIGHT.medium} />
  </InputControl>
);
